export const MIME_TYPE = {
    JSON: '*',
    IMAGE: 'image/*',
    IMAGE_PNG_JPG: 'image/png, image/jpeg',
};

export const API_CODE = {
    SUCCESS: '0',
    FAIL: '2'
};

export const MODE_VIEW = {
    EDIT: 'EDIT',
    DETAIL: 'DETAIL',
    NEW: 'NEW',
};

export const CAMERA_STATUS = {
    PLAY: 'PLAY',
    STOP: 'STOP',
    PAUSE: 'PAUSE',
    RESUME: 'RESUME',
};

export const ROLE_CODE = {
    ADMIN: 'ADMIN',
    EDITOR: 'EDITOR',
    VIEWER: 'VIEWER',
};

export const STATUS_COLOR = {
    GREEN: '#008348',
    GRAY: '#8E8E8E',
    YELLOW: '#ffb300',
};

export const KEY_SETTING = {
    NEC_EVA_URL: 'NEC_EVA_URL',
    NEC_EVA_ACCOUNT: 'NEC_EVA_ACCOUNT',
    NEC_DSA_SERVER: 'NEC_DSA_SERVER',
    NEC_QUERY_SERVER: 'NEC_QUERY_SERVER',
    NEC_DSA_ACCOUNT: 'NEC_DSA_ACCOUNT',
    NEC_EVA_ZMQ_INSTANCE: 'NEC_EVA_ZMQ_INSTANCE',
    NEC_EVA_LIVE_VIEW: 'NEC_EVA_LIVE_VIEW',
    NEC_EVA_IMAGE_SENSOR_KNOWN: 'NEC_EVA_IMAGE_SENSOR_KNOWN',
    NEC_EVA_IMAGE_SENSOR_UNKNOWN: 'NEC_EVA_IMAGE_SENSOR_UNKNOWN',
    DISPLAY_TIMEZONE: 'DISPLAY_TIMEZONE',
    NEC_EVA_BIOMETRIC_INSTANCE: 'NEC_EVA_BIOMETRIC_INSTANCE',
    NEC_EVA_ALERT_INSTANCE: 'NEC_EVA_ALERT_INSTANCE',
    DISPLAY_VIDEO_WIDTH_HEIGHT: 'DISPLAY_VIDEO_WIDTH_HEIGHT',
    SYNC_SENSOR_USE_CASES: 'SYNC_SENSOR_USE_CASES',
    NEC_EVA_PERSON_WATCHLIST: 'NEC_EVA_PERSON_WATCHLIST',
    NEC_DSA_PERSON_WATCHLIST: 'NEC_DSA_PERSON_WATCHLIST',
    APP_TITLE: 'APP_TITLE',
    DSA_MENU: 'DSA_MENU',
    LIVE_VIEW: 'LIVE_VIEW',
    VMS_VIEW: 'VMS_VIEW',
    CROWD_COUNT: 'CROWD_COUNT',
    PEOPLE_COUNT: 'PEOPLE_COUNT',
    SEARCH_VIEW: 'SEARCH_VIEW',
    IMAGE_VIEW: 'IMAGE_VIEW',
    DEMO_MENU: 'DEMO_MENU',
    EVA_MENU: 'EVA_MENU'
};

export const SCHEDULE_TIME = {
    START_TIME: '08:00',
    END_TIME: '22:00',
};

export const SESSION_STATUS = {
    SCHEDULED: 'SCHEDULED',
    PROGRESS: 'IN PROGRESS',
    COMPLETED: 'COMPLETED',
};

export const ASSESSMENT_STATUS = {
    ANNOTATED: 'ANNOTATED',
};

export const IMG_TYPE = 'image/jpeg';
export const VIDEO_TYPE = 'video/webm';

export const SCREEN_NAME = {
    TabSessionsDetail: 'TabSessionsDetail',
};

// Default Mapbox coordinate: Singapore
export const MAP_COORDS = [103.8198, 1.3521];
export const MAPBOX_APIKEY = 'pk.eyJ1IjoibmdvY3RoYW5oY3IiLCJhIjoiY2p2bjdycmUyMWdnNjRiczJqdWlzODEwMSJ9.GM-cBAR1on6hA5oPeDJFrg';
export const SINGAPORE_BBOX = [[103.491212211768, 1.09856456141626, 104.10644622388, 1.4778763957108]];
export const SINGAPORE_BOUNDS = [
    [103.491212211768, 1.09856456141626],
    [104.10644622388, 1.4778763957108],
];
export const TEST_BOUNDS = [
    [17.5764426321, 59.8581348075],
    [17.5872125208, 59.8581348075],
    [17.5872125208, 59.8538294394],
    [17.5764426321, 59.8538294394],
];

export const MAP_ICON = {};
export const MAP_MATERIAL_ICON = {};

export const GL_DRAW_LAYERS = [
    'gl-draw-polygon-fill-inactive.cold',
    'gl-draw-polygon-fill-active.cold',
    'gl-draw-polygon-midpoint.cold',
    'gl-draw-polygon-stroke-inactive.cold',
    'gl-draw-polygon-stroke-active.cold',
    'gl-draw-line-inactive.cold',
    'gl-draw-line-active.cold',
    'gl-draw-polygon-and-line-vertex-stroke-inactive.cold',
    'gl-draw-polygon-and-line-vertex-inactive.cold',
    'gl-draw-point-point-stroke-inactive.cold',
    'gl-draw-point-inactive.cold',
    'gl-draw-point-stroke-active.cold',
    'gl-draw-point-active.cold',
    'gl-draw-polygon-fill-static.cold',
    'gl-draw-polygon-stroke-static.cold',
    'gl-draw-line-static.cold',
    'gl-draw-point-static.cold',
    'gl-draw-polygon-fill-inactive.hot',
    'gl-draw-polygon-fill-active.hot',
    'gl-draw-polygon-midpoint.hot',
    'gl-draw-polygon-stroke-inactive.hot',
    'gl-draw-polygon-stroke-active.hot',
    'gl-draw-line-inactive.hot',
    'gl-draw-line-active.hot',
    'gl-draw-polygon-and-line-vertex-stroke-inactive.hot',
    'gl-draw-polygon-and-line-vertex-inactive.hot',
    'gl-draw-point-point-stroke-inactive.hot',
    'gl-draw-point-inactive.hot',
    'gl-draw-point-stroke-active.hot',
    'gl-draw-point-active.hot',
    'gl-draw-polygon-fill-static.hot',
    'gl-draw-polygon-stroke-static.hot',
    'gl-draw-line-static.hot',
    'gl-draw-point-static.hot',
];

export const MAPBOX_INDOOR_LAYER = [
    {
        filter: ['any', ['has', 'building'], ['has', 'building-part']],
        id: 'buildings-background',
        type: 'fill',
        source: 'indoor',
        paint: {
            'fill-color': '#DCD9D6',
            'fill-opacity': {
                base: 1,
                stops: [
                    [13.5, 0],
                    [15, 0.5],
                ],
            },
        },
    },
    {
        filter: ['filter-==', 'indoor', 'level'],
        id: 'level-background',
        type: 'fill',
        source: 'indoor',
        paint: {
            'fill-color': '#DCD9D6',
            'fill-opacity': {
                base: 1,
                stops: [
                    [13.5, 0],
                    [15, 0.5],
                ],
            },
        },
    },
    {
        id: 'indoor-gardens',
        type: 'fill',
        source: 'indoor',
        filter: ['filter-==', 'leisure', 'garden'],
        layout: {
            visibility: 'visible',
        },
        paint: {
            'fill-color': '#cde8a2',
            'fill-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [15, 0.5],
                ],
            },
        },
    },
    {
        filter: ['filter-==', 'amenity', 'parking'],
        id: 'indoor-parkings',
        type: 'fill',
        source: 'indoor',
        paint: {
            'fill-color': '#D7CCC8',
            'fill-outline-color': '#000000',
            'fill-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [15, 0.5],
                ],
            },
        },
    },
    {
        filter: ['filter-==', 'amenity', 'parking'],
        id: 'indoor-parkings-patterns',
        type: 'fill',
        source: 'indoor',
        paint: {
            'fill-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [15, 0.1],
                ],
            },
            'fill-pattern': 'si-main-3',
            'fill-translate-anchor': 'viewport',
        },
    },
    {
        filter: ['filter-==', 'indoor', 'corridor'],
        id: 'indoor-corridors',
        type: 'fill',
        source: 'indoor',
        paint: {
            'fill-color': '#D7CCC8',
            'fill-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [15, 0.5],
                ],
            },
        },
    },
    {
        filter: ['filter-==', 'indoor', 'room'],
        id: 'indoor-rooms',
        type: 'fill',
        source: 'indoor',
        paint: {
            'fill-color': '#A1887F',
            'fill-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [15, 0.5],
                ],
            },
        },
    },
    {
        filter: ['any', ['filter-==', 'indoor', 'room'], ['filter-==', 'indoor', 'area']],
        id: 'indoor-rooms-borders',
        type: 'line',
        source: 'indoor',
        paint: {
            'line-color': '#000',
            'line-width': 1,
            'line-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [15, 1],
                ],
            },
        },
    },
    {
        filter: ['filter-==', 'indoor', 'area'],
        id: 'indoor-areas',
        type: 'fill',
        source: 'indoor',
        paint: {
            'fill-color': '#D7CCC8',
            'fill-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [15, 0.5],
                ],
            },
        },
    },
    {
        filter: ['all', ['filter-==', 'indoor', 'area'], ['filter-==', 'balcony', 'yes']],
        id: 'indoor-balcony',
        type: 'fill',
        source: 'indoor',
        paint: {
            'fill-color': '#BDBDBD',
            'fill-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [15, 0.5],
                ],
            },
        },
    },
    {
        filter: ['any', ['filter-==', 'stairs', 'yes'], ['filter-==', 'elevator', 'yes']],
        id: 'indoor-stairs',
        type: 'fill',
        source: 'indoor',
        paint: {
            'fill-color': '#7B635A',
            'fill-outline-color': '#000000',
            'fill-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [15, 0.5],
                ],
            },
        },
    },
    {
        filter: ['filter-==', 'indoor', 'wall'],
        id: 'indoor-walls',
        type: 'line',
        source: 'indoor',
        paint: {
            'line-color': '#000000',
            'line-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [15, 1],
                ],
            },
        },
    },
    {
        filter: ['has', 'barrier'],
        id: 'indoor-barriers',
        type: 'line',
        source: 'indoor',
        paint: {
            'line-color': '#000000',
            'line-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [15, 1],
                ],
            },
        },
    },
    {
        filter: ['filter-==', 'indoor', 'block'],
        id: 'indoor-blocks',
        type: 'fill',
        source: 'indoor',
        paint: {
            'fill-color': '#000000',
            'fill-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [15, 0.5],
                ],
            },
        },
    },
    {
        filter: ['filter-==', 'handrail', 'yes'],
        id: 'indoor-handrail',
        type: 'line',
        source: 'indoor',
        paint: {
            'line-color': '#000000',
            'line-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [16, 1],
                ],
            },
        },
    },
    {
        filter: [
            'any',
            ['filter-in-small', 'indoor', ['literal', ['table', 'cupboard', 'chair', 'kitchen', 'sofa', 'tv', 'shelf']]],
            ['filter-==', 'trashcan', 'yes'],
            ['filter-==', 'copier', 'yes'],
        ],
        id: 'indoor-furniture',
        type: 'fill',
        source: 'indoor',
        paint: {
            'fill-color': '#000',
            'fill-outline-color': '#000',
            'fill-opacity': {
                base: 1,
                stops: [
                    [15, 0],
                    [16, 0.2],
                ],
            },
        },
    },
    {
        filter: ['filter-==', 'indoor', 'level'],
        id: 'level',
        type: 'line',
        source: 'indoor',
        paint: {
            'line-color': '#000000',
            'line-width': {
                base: 2,
                stops: [
                    [13.5, 0],
                    [15, 2],
                ],
            },
            'line-opacity': {
                base: 1,
                stops: [
                    [13.5, 0],
                    [15, 1],
                ],
            },
        },
    },
    {
        id: 'indoor-steps',
        paint: {
            'line-width': {
                base: 1.5,
                stops: [
                    [12, 1],
                    [13, 1.6],
                    [15, 6],
                ],
            },
            'line-color': 'hsl(0, 0%, 100%)',
            'line-dasharray': {
                base: 1,
                stops: [
                    [11, [1, 0]],
                    [12, [1.75, 1]],
                    [13, [1, 0.75]],
                    [14, [0.3, 0.3]],
                ],
            },
            'line-opacity': {
                base: 1,
                stops: [
                    [11, 0],
                    [11.25, 1],
                ],
            },
        },
        type: 'line',
        source: 'indoor',
        filter: ['all', ['filter-==', 'highway', 'steps'], ['!', ['has', 'conveying']]],
        layout: {
            'line-join': 'round',
        },
    },
    {
        id: 'indoor-conveying',
        paint: {
            'line-width': {
                base: 1.5,
                stops: [
                    [12, 1],
                    [13, 1.6],
                    [15, 6],
                ],
            },
            'line-color': '#FF0000',
            'line-dasharray': {
                base: 1,
                stops: [
                    [11, [1, 0]],
                    [12, [1.75, 1]],
                    [13, [1, 0.75]],
                    [14, [0.3, 0.3]],
                ],
            },
            'line-opacity': {
                base: 1,
                stops: [
                    [11, 0],
                    [11.25, 1],
                ],
            },
        },
        type: 'line',
        source: 'indoor',
        filter: ['all', ['filter-==', 'highway', 'steps'], ['has', 'conveying']],
        layout: {
            'line-join': 'round',
        },
    },
    {
        interactive: true,
        minzoom: 14,
        layout: {
            'text-line-height': 1.2,
            'text-size': {
                base: 1,
                stops: [
                    [14, 10],
                    [17, 12],
                ],
            },
            'text-allow-overlap': false,
            'text-ignore-placement': false,
            'text-max-angle': 38,
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Regular'],
            'symbol-placement': 'point',
            'text-padding': 2,
            'visibility': 'visible',
            'text-rotation-alignment': 'viewport',
            'text-anchor': 'center',
            'text-field': '{name}',
            'text-letter-spacing': 0.02,
            'text-max-width': 8,
        },
        filter: ['filter-==', 'indoor', 'room'],
        type: 'symbol',
        source: 'indoor',
        id: 'poi-indoor-text-ref',
        paint: {
            'text-color': '#65513d',
            'text-halo-color': '#ffffff',
            'text-halo-width': 1,
            'text-opacity': {
                base: 1,
                stops: [
                    [15, 0],
                    [15.5, 0.5],
                    [16, 1],
                ],
            },
        },
    },
    {
        interactive: true,
        minzoom: 14,
        layout: {
            'text-line-height': 1.2,
            'icon-size': {
                base: 1,
                stops: [
                    [14, 0.5],
                    [17, 1],
                ],
            },
            'text-size': {
                base: 1,
                stops: [
                    [14, 11],
                    [17, 13],
                ],
            },
            'text-allow-overlap': false,
            'icon-image': '{maki}-15',
            'icon-anchor': 'center',
            'text-ignore-placement': false,
            'text-max-angle': 38,
            'symbol-spacing': 250,
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Regular'],
            'symbol-placement': 'point',
            'text-padding': 2,
            'visibility': 'visible',
            'text-offset': [0, 1],
            'icon-optional': false,
            'text-rotation-alignment': 'viewport',
            'text-anchor': 'top',
            'text-field': '{name}',
            'text-letter-spacing': 0.02,
            'text-max-width': 8,
            'icon-allow-overlap': true,
        },
        filter: ['boolean', false],
        type: 'symbol',
        source: 'indoor',
        id: 'poi-indoor',
        paint: {
            'text-color': '#65513d',
            'text-halo-color': '#ffffff',
            'text-halo-width': 1,
            'text-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [14.5, 0.5],
                    [16, 1],
                ],
            },
            'icon-opacity': {
                base: 1,
                stops: [
                    [14, 0],
                    [14.5, 0.5],
                    [16, 1],
                ],
            },
        },
    },
];

export const TOPIC = {
    LIVE_EVENTS: 'live.events',
    LIVE_ALERTS: 'live.alerts',
    LIVE_TRAJECTORY: 'trajectory',
};

export const FACILITY_TYPE = {
    GEOJSON: 'geojson',
    STATIC: 'static',
};

export const LAYOUT_CONFIG_COMMON = {
    global: {
        splitterSize: 8,
        enableEdgeDock: false,
        tabEnableClose: false,
        tabCloseType: 1,
        tabEnableDrag: true,
        tabEnableRename: false,
        tabEnableFloat: false,
        tabClassName: null,
        tabIcon: null,
        tabEnableRenderOnDemand: true,
        tabDragSpeed: 0.3,
        tabSetEnableDeleteWhenEmpty: true,
        tabSetEnableDrop: true,
        tabSetEnableDrag: true,
        tabSetEnableDivide: true,
        tabSetEnableMaximize: true,
        tabSetAutoSelectTab: true,
        tabSetClassNameTabStrip: null,
        tabSetClassNameHeader: null,
        tabSetEnableTabStrip: true,
        tabSetHeaderHeight: 0,
        tabSetTabStripHeight: 0,
        borderBarSize: 0,
        borderEnableDrop: true,
        borderAutoSelectTabWhenOpen: true,
        borderAutoSelectTabWhenClosed: false,
        borderClassName: null,
        borderSize: 200,
        borderMinSize: 0,
        tabSetMinHeight: 250,
        tabSetMinWidth: 300,
        tabSetTabLocation: 'top',
        rootOrientationVertical: false,
    },
    borders: [],
};

export const TYPE_ALERT = {
    CROWD_COUNT: 'crowd-count',
    FACE_MATCH: 'facematch',
    FACE_ENROLL: 'face-enroll',
    PEOPLE_COUNTING_IN: 'people-counting-in',
    PEOPLE_COUNTING_OUT: 'people-counting-out',
};

export const TYPE_PRIORITY = {
    HIGH: 'HIGH',
    MEDIUM: 'MEDIUM',
    LOW: 'LOW',
};

export const CAMERA_TYPE = {
    DSA: 'rgb-camera',
    EVA: 'camera',
    DEMOSENSOR: 'DEMOSENSOR'
};

export const SOURCE = {
    PPRS: 'pprs',
    COLLEAUGE_FINDER: 'colleague-finder'
}

export const TARGET = 'target';